import React, { Fragment } from "react";
import Card from "react-bootstrap/Card";
import { OutboundLink } from "react-ga";
import PropTypes from "prop-types";
import Skeleton from "react-loading-skeleton";
import classNames from "classnames";
import empty from "../assets/empty.png";
import styles from "../styles/ArticlePreview.module.scss";
import useDarkMode from "use-dark-mode";

const ArticlePreview = ({ author, date, excerpt, isLoading, link, media, small, tags, title }) => {
  const darkMode = useDarkMode(false);
  return (
    <div className={classNames(styles.container, { [styles.dark]: darkMode.value })}>
      <Card className={classNames("shadow-sm", styles.card)}>
        <Card.Img
          className={classNames(styles.media, { [styles.mediaSmall]: small })}
          variant="top"
          src={isLoading ? empty : media}
        />
        <Card.Body className={styles.cardBody}>
          <div>
            {isLoading ? (
              <div className={classNames(styles.avatar, { [styles.avatarSmall]: small })}>
                <img alt="Loading" src={empty} />
              </div>
            ) : (
              <OutboundLink
                eventLabel={author.link}
                rel="noreferrer"
                target="_blank"
                to={author.link}
              >
                <div className={classNames(styles.avatar, { [styles.avatarSmall]: small })}>
                  <img alt={author.name} src={author.avatar} />
                </div>
              </OutboundLink>
            )}
            <div className={styles.row}>
              <div className={styles.date}>{isLoading ? <Skeleton /> : date}</div>
              <div className={styles.author}>
                {isLoading ? (
                  <Skeleton />
                ) : (
                  <OutboundLink
                    dangerouslySetInnerHTML={{ __html: author.name }}
                    eventLabel={link}
                    rel="noreferrer"
                    target="_blank"
                    to={author.link}
                  ></OutboundLink>
                )}
              </div>
            </div>
            <h5 className={styles.title}>
              {isLoading ? (
                <Skeleton count={2} />
              ) : (
                <OutboundLink eventLabel={link} rel="noreferrer" target="_blank" to={link}>
                  {title}
                </OutboundLink>
              )}
            </h5>
            <div className={classNames(styles.excerpt, { [styles.excerptSmall]: small })}>
              {isLoading ? <Skeleton count={2} /> : excerpt}
            </div>
          </div>
          {tags && (
            <div>
              <hr />
              <div className={styles.tags}>
                {tags.map(({ link, name }, i) => (
                  <Fragment key={link}>
                    <OutboundLink eventLabel={link} rel="noreferrer" target="_blank" to={link}>
                      {`#${name}`}
                    </OutboundLink>
                    {i !== tags.length - 1 && ", "}
                  </Fragment>
                ))}
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

ArticlePreview.propTypes = {
  author: PropTypes.shape({
    avatar: PropTypes.string,
    link: PropTypes.string,
    name: PropTypes.string,
  }),
  date: PropTypes.string,
  excerpt: PropTypes.string,
  isLoading: PropTypes.bool,
  link: PropTypes.string,
  media: PropTypes.string,
  small: PropTypes.bool,
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  title: PropTypes.string,
};

export default ArticlePreview;
